import React, { Children } from 'react';
import { DatabaseIcon, UsersIcon, SearchIcon, ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export const USPBar: React.FC = () => {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 100
      }
    }
  };
  return <div className="w-full relative" data-id="element-680">
      {/* Blue background bar for the top half */}
      <div className="absolute top-0 left-0 w-full h-1/2 bg-[#004AC7] z-0" data-id="element-681"></div>
      <div className="absolute bottom-0 left-0 w-full h-1/2 z-0 bg-[#004AC7]" data-id="element-682"></div>

      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10 py-8" data-id="element-683">
        <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
        once: true
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-684">
          {/* Card 1 - CorePrint */}
          <motion.div variants={itemVariants} whileHover={{
          y: -5,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} className="bg-white rounded-xl p-6 shadow-lg transition-all duration-300 flex flex-col h-full border border-gray-100" data-id="element-685">
            <div className="bg-[#EEF5FA] rounded-lg p-3 mb-5 inline-flex w-fit" data-id="element-686">
              <DatabaseIcon className="h-6 w-6 text-[#004AC7]" data-id="element-687" />
            </div>
            <h3 className="font-bold text-[#111827] mb-3 text-lg leading-tight" data-id="element-688">
              CorePrint, groei op basis van data
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-grow" data-id="element-689">
              Stop met gissen. Start met bewijs. In 90 dagen weet je welke
              keywords in jouw markt daadwerkelijk aanvragen opleveren.
            </p>
            <a href="https://coreprint.nl/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-[#004AC7] font-semibold text-sm hover:text-[#003A9E] transition-colors group mt-auto" data-id="element-690">
              Ontdek CorePrint
              <ArrowRightIcon className="ml-1.5 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-691" />
            </a>
          </motion.div>

          {/* Card 2 - Buiten de via-via loop */}
          <motion.div variants={itemVariants} whileHover={{
          y: -5,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} className="bg-white rounded-xl p-6 shadow-lg transition-all duration-300 flex flex-col h-full border border-gray-100" data-id="element-692">
            <div className="bg-[#EEF5FA] rounded-lg p-3 mb-5 inline-flex w-fit" data-id="element-693">
              <UsersIcon className="h-6 w-6 text-[#004AC7]" data-id="element-694" />
            </div>
            <h3 className="font-bold text-[#111827] mb-3 text-lg leading-tight" data-id="element-695">
              Niet meer afhankelijk van via via
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-grow" data-id="element-696">
              Structureel nieuwe klanten aantrekken via bewezen online kanalen.
              Voorspelbaar en schaalbaar.
            </p>
            <a href="#services" className="inline-flex items-center text-[#004AC7] font-semibold text-sm hover:text-[#003A9E] transition-colors group mt-auto" data-id="element-697">
              Hoe wij dat doen
              <ArrowRightIcon className="ml-1.5 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-698" />
            </a>
          </motion.div>

          {/* Card 3 - SEO zonder giswerk */}
          <motion.div variants={itemVariants} whileHover={{
          y: -5,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} className="bg-white rounded-xl p-6 shadow-lg transition-all duration-300 flex flex-col h-full border border-gray-100" data-id="element-699">
            <div className="bg-[#EEF5FA] rounded-lg p-3 mb-5 inline-flex w-fit" data-id="element-700">
              <SearchIcon className="h-6 w-6 text-[#004AC7]" data-id="element-701" />
            </div>
            <h3 className="font-bold text-[#111827] mb-3 text-lg leading-tight" data-id="element-702">
              SEO die wél converteert
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed mb-6 flex-grow" data-id="element-703">
              Geen duur SEO-pakket op basis van aannames. Wij bouwen je online
              aanwezigheid op data die bewezen converteert.
            </p>
            <a href="/seo" className="inline-flex items-center text-[#004AC7] font-semibold text-sm hover:text-[#003A9E] transition-colors group mt-auto" data-id="element-704">
              Bekijk onze aanpak
              <ArrowRightIcon className="ml-1.5 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-705" />
            </a>
          </motion.div>

          {/* Card 4 - SBB Erkend Leerbedrijf */}
          <motion.div variants={itemVariants} whileHover={{
          y: -5,
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }} className="bg-white rounded-xl p-6 shadow-lg transition-all duration-300 flex flex-col items-center justify-center h-full border border-gray-100" data-id="element-706">
            <img src="https://cdn.magicpatterns.com/uploads/1aHtpkWESLeaWQNYKA51qz/WhatsApp_Image_2026-02-28_at_14.34.29.jpg" alt="S-BB Erkend Leerbedrijf" className="w-full max-w-[180px] h-auto object-contain mb-6" data-id="element-707" />
            <a href="/sollicitatie" className="inline-flex items-center justify-center w-full bg-[#004AC7] text-white font-semibold py-3 px-4 rounded-lg hover:bg-[#003A9E] transition-colors mt-auto" data-id="element-708">
              Bekijk vacatures
              <ArrowRightIcon className="ml-1.5 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-709" />
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>;
};